export const h100Products = [
  // ===== 첫 번째 사진 (POR009~BON023) - 15개 =====
  {
    id: 'h100-1',
    name: 'POR009',
    description: 'HEAD LAMP',
    partNumber: '92101-4F010 L / 92102-4F010 R',
    price: 0,
    image: 'https://public.readdy.ai/ai/img_res/171e459b97971cc0417d32bc4bf98309.jpg',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-2',
    name: 'POR010',
    description: 'HEAD LAMP',
    partNumber: '92101-4F030 L / 92101-4F510 L / 92102-4F030R / 92102-4F510R / 92101-4F500L / 92102-4F500 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20headlamp%20assembly%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por010&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-3',
    name: 'POR011',
    description: 'HEAD LAMP',
    partNumber: '92101-4F700 L / 92102-4F700 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20headlamp%20light%20assembly%20chrome%20housing%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por011&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-4',
    name: 'POR012',
    description: 'HEAD LAMP BLACK',
    partNumber: '92101-4F700B L / 92102-4F700B R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20headlamp%20black%20housing%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por012&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-5',
    name: 'POR013',
    description: 'FOG LAMP',
    partNumber: '92201-4F000 L / 92202-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20fog%20lamp%20round%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por013&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-6',
    name: 'POR014',
    description: 'FOG LAMP',
    partNumber: '92201-4F500 L / 92202-4F500 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20fog%20lamp%20assembly%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por014&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-7',
    name: 'POR015',
    description: 'TAIL LAMP',
    partNumber: '92401-4F000 L / 92402-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20tail%20lamp%20red%20lens%20assembly%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por015&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-8',
    name: 'POR016',
    description: 'TAIL LAMP LED',
    partNumber: '92401-4F030 L / 92402-4F030 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20LED%20tail%20lamp%20red%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por016&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-9',
    name: 'POR017',
    description: 'SIDE LAMP',
    partNumber: '92305-26000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20side%20lamp%20indicator%20light%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por017&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-10',
    name: 'POR018',
    description: 'MIRROR',
    partNumber: '87610-4F000 L / 87620-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20side%20mirror%20assembly%20black%20housing%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por018&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-11',
    name: 'POR019',
    description: 'MIRROR',
    partNumber: '87610-4F600 L / 87620-4F600 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20side%20mirror%20assembly%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por019&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-12',
    name: 'POR020',
    description: 'BUMPER',
    partNumber: '86510-4F100',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20front%20bumper%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por020&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-13',
    name: 'POR021',
    description: 'BUMPER',
    partNumber: '86510-4F010',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20front%20bumper%20assembly%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por021&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-14',
    name: 'BON022',
    description: 'GRILLE',
    partNumber: '86512-4F000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20front%20grille%20black%20chrome%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-bon022&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-15',
    name: 'BON023',
    description: 'HANDLE',
    partNumber: '82610-4F000 L / 82620-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20handle%20chrome%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-bon023&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  // ===== 두 번째 사진 (POR024~POR040) - 15개 =====
  {
    id: 'h100-16',
    name: 'POR024',
    description: 'HANDLE',
    partNumber: '82650-4F000 L / 82660-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20exterior%20door%20handle%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por024&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-17',
    name: 'POR025',
    description: 'HANDLE',
    partNumber: 'POR025',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20handle%20assembly%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por025&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-18',
    name: 'POR026',
    description: 'MUD GUARD',
    partNumber: '61210-4F010 / 61220-4F010',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20mud%20guard%20flap%20rubber%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por026&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-19',
    name: 'POR027',
    description: 'WATER TANK',
    partNumber: '25430-4F100',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20water%20tank%20reservoir%20coolant%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por027&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-20',
    name: 'POR028',
    description: 'BUMPER',
    partNumber: '86511-4F500',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20bumper%20section%20gray%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por028&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-21',
    name: 'POR029',
    description: 'BUMPER',
    partNumber: '86510-4E010',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20front%20bumper%20assembly%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por029&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-22',
    name: 'POR030',
    description: 'MUD GUARD',
    partNumber: '86831-4F000 L / 86832-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20mud%20guard%20fender%20liner%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por030&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-23',
    name: 'POR031',
    description: 'PANEL',
    partNumber: '66400-4F000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20body%20panel%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por031&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-24',
    name: 'POR032',
    description: 'PANEL',
    partNumber: '66400-4F510',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20body%20panel%20assembly%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por032&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-25',
    name: 'POR033',
    description: 'FENDER',
    partNumber: '66310-4F000 L / 66320-4F000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20fender%20panel%20metal%20body%20part%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por033&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-26',
    name: 'POR034',
    description: 'BUMPER SUPPORT',
    partNumber: '86530-4F000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20bumper%20support%20bracket%20metal%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por034&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-27',
    name: 'POR035',
    description: 'DOOR',
    partNumber: '76003-4F010 L / 76004-4F010 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20panel%20assembly%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por035&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-28',
    name: 'POR037',
    description: 'DOOR SILL PANEL',
    partNumber: 'POR037',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20sill%20panel%20trim%20piece%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por037&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-29',
    name: 'POR038',
    description: 'DOOR SILL PANEL',
    partNumber: 'POR038',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20sill%20panel%20step%20trim%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por038&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-30',
    name: 'POR040',
    description: 'BUMPER SUPPORT',
    partNumber: '86530-4F500',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20bumper%20support%20reinforcement%20bracket%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por040&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  // ===== 세 번째 사진 (POR042~POR044) - 3개 =====
  {
    id: 'h100-31',
    name: 'POR042',
    description: 'INNER FENDER',
    partNumber: '86811-4F010L / 86812-4F010R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20inner%20fender%20liner%20plastic%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por042&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-32',
    name: 'POR043',
    description: 'DOOR SILL PANEL',
    partNumber: '71170-4F400L / 71180-4F400R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20door%20sill%20panel%20lower%20trim%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por043&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  {
    id: 'h100-33',
    name: 'POR044',
    description: 'PILLAR ASSY',
    partNumber: '71231-4F401L / 71241-4F401R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20truck%20pillar%20assembly%20body%20structure%20part%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-por044&orientation=squarish',
    category: 'HYUNDAI H100',
    inStock: true,
  },
  // ===== HYUNDAI H100 VAN 부품 (HDM008~HDM024) - 15개 =====
  {
    id: 'h100-van-1',
    name: 'HDM008',
    description: 'HEAD LAMP',
    partNumber: '92101-6B003 L / 92102-68003 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20headlamp%20clear%20lens%20assembly%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm008&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-2',
    name: 'HDM009',
    description: 'FOG LAMP',
    partNumber: '92201-6B000 L / 92202-6B000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20fog%20lamp%20round%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm009&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-3',
    name: 'HDM020',
    description: 'AUTO LAMP',
    partNumber: '92401-7A100 L / 92402-7A100 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20tail%20lamp%20red%20lens%20assembly%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm020&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-4',
    name: 'HDM020LED',
    description: 'TAIL LAMP(LED)',
    partNumber: 'HDM020LED',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20LED%20tail%20lamp%20red%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm020led&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-5',
    name: 'HDM010',
    description: 'CORNER LAMP',
    partNumber: '92301-6B100 L / 92302-6B100 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20corner%20lamp%20indicator%20light%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm010&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-6',
    name: 'HDM011',
    description: 'GRILLE',
    partNumber: '86310-6C101',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20front%20grille%20black%20chrome%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm011&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-7',
    name: 'HDM012',
    description: 'HANDLE',
    partNumber: '82330-7C000 L / 82340-7C000 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20door%20handle%20chrome%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm012&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-8',
    name: 'HDM013',
    description: 'HANDLE',
    partNumber: '82310-7A002 L / 82320-7A002 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20door%20handle%20assembly%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm013&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-9',
    name: 'HDM014',
    description: 'HANDLE',
    partNumber: '82330-7A001 L / 82340-7A001 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20exterior%20door%20handle%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm014&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-10',
    name: 'HDM015',
    description: 'CORNER PANEL',
    partNumber: '82710-6B002 L / 82720-6B003 R',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20corner%20panel%20body%20part%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm015&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-11',
    name: 'HDM016',
    description: 'DOOR SILL PANEL',
    partNumber: '71355-43002 / 71151-43003',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20door%20sill%20panel%20trim%20piece%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm016&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-12',
    name: 'HDM017',
    description: 'FRONT PANEL',
    partNumber: '71500-6B000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20front%20panel%20body%20part%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm017&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-13',
    name: 'HDM021',
    description: 'SUNVISOR',
    partNumber: '86251-4B100 / 86252-4B100 / 86253-4B000 / 86254-4B000 / 86255-4B110 / 86290-4B110',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20sunvisor%20interior%20accessory%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm021&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-14',
    name: 'HDM022',
    description: 'TOP LAMP',
    partNumber: '92670-6C000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20top%20lamp%20roof%20light%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm022&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
  {
    id: 'h100-van-15',
    name: 'HDM024',
    description: 'CORNER PANEL',
    partNumber: '86315-6C000 / 86325-6C000',
    price: 0,
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20H100%20VAN%20corner%20panel%20body%20trim%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20professional&width=400&height=400&seq=h100-van-hdm024&orientation=squarish',
    category: 'HYUNDAI H100 VAN',
    inStock: true,
  },
];
